<script setup lang="ts">
import type { HTMLAttributes } from 'vue'
import type { PrimitiveProps } from 'reka-ui'

import { cn } from 'cn'

import type { ButtonIconVariants } from './variants'

import { buttonIconVariants } from './variants'

export interface Props extends PrimitiveProps {
  size: ButtonIconVariants['size']
  class?: HTMLAttributes['class']
  name: string
}

const props = defineProps<Props>()
</script>

<template>
  <UiIcon
    :class="cn(buttonIconVariants({ size }), props.class)"
    :name
  />
</template>
